import { render, staticRenderFns } from "./DigestNotifications.vue?vue&type=template&id=4049e717&"
import script from "./DigestNotifications.vue?vue&type=script&lang=js&"
export * from "./DigestNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports